import { render, staticRenderFns } from "./QualificationPage.vue?vue&type=template&id=f86f4106&"
import script from "./QualificationPage.vue?vue&type=script&lang=js&"
export * from "./QualificationPage.vue?vue&type=script&lang=js&"
import style0 from "./QualificationPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports